export const ShowColumns = {
  SUB_INSTITUTION_ID: 'SUB_INSTITUTION_ID',
  META_DATA_1: 'META_DATA_1',
};
